<template>
  <Body class="page-view page-video-view" />

  <!-- post header -->
  <section class="section post-header">
    <!-- auto translate -->
    <!-- <div class="wrap auto-translate">
      <div class="translate-guide">
        {{ $t('이글은자동번역되었어요') }} {{ $t('번역이어색하거나원글과다소다를수있어요') }}
      </div>
    </div> -->

    <div class="wrap">
      <h1 class="post-title">
        {{ video?.title }}
      </h1>
      <div class="post-info">
        <div class="detail">
          <div class="view">
            <i class="ico ico-smile" />{{ formatNumber(video?.viewCnt ?? 0, locale) }}
          </div>
          <div class="like">
            <i class="ico ico ico-heart-round" />{{ formatNumber(video?.likeCnt ?? 0, locale) }}
          </div>
        </div>
      </div>
    </div>
  </section>


  <!-- video player -->
  <section class="section post-video">
    <div v-if="video?.embedYoutubeId" class="wrap">
      <div class="video-area" style="position:relative; width:100%; height:0; padding-bottom:56.25%; color:#FFF;">
      <client-only>
        <VideoYoutubePlayer :video-id="video?.embedYoutubeId" />
      </client-only>
      </div>
    </div>
    <div v-if="video?.embedVideoUrl" class="wrap"> 
      <div class="video-area" style="position:relative; width:100%; height:0; padding-bottom:56.25%; color:#FFF;">
        <client-only>
          <VideoWatvPlayer :video-url="video?.embedVideoUrl" />
        </client-only>
      </div>
    </div>
  </section>


  <!-- post contents -->
  <section class="section post-contents">
    <div class="wrap">
      <!-- content -->
      <div class="contents-container we-contents" v-html="video?.contents">
      </div>

      <!-- rights -->
      <div class="rights">
        {{ $t('무단전재및재배포금지') }}
      </div>

      <!-- likes -->
      <div class="like-wrap">
        <button type="button" class="btn-like" @click="onClickLikeButton">
          <ClientOnly>
            <Vue3Lottie
              ref="lottie"
              :animation-data="likeJSON"
              :speed="1"
              :auto-play="false"
              :loop="false"
              @on-animation-loaded="onAnimationLoaded"
            />
          </ClientOnly>
        </button>
        <div class="like-count">
          {{ formatNumber(video?.likeCnt ?? 0, locale) }}
        </div>
      </div>

      <div class="btns">
        <a class="btn" @click="$router.back()">{{ $t('뒤로가기') }}</a>
      </div>
    </div>
  </section>

</template>

<script lang="ts" setup>
import type { VideoDetailModel } from '~~/shared/types/models';

const { $t } = useNuxtApp()
const route = useRoute();
const id = route.params.id;

const { locale } = useI18n();
const { data: video, refresh } = await useFetch<VideoDetailModel>(`/api/videos/${id}`, {
  method: 'GET',
  query: {
    languageGbSn: locale.value,
  },
});

useHead({
  title: `${video.value?.title} - ${$t('어머니사랑과평화의날캠페인')}` ,
  link: [{ rel: 'stylesheet', href: `/css/video.css?${useBuildTime()}` }],
})

// lottie
import { Vue3Lottie } from 'vue3-lottie'
import likeJSON from '@/assets/lotties/like.json'
import 'swiper/css'


const lottie = ref<any>(null)
function onAnimationLoaded(_: any) {
  if (video.value?.isLiked) {
    const duration = lottie.value.getDuration()
    lottie.value.goToAndStop(duration)
  }
}

const { isLoggedIn, showLoginPopup } = useAuth()
async function onClickLikeButton() {
  const videoId = video.value?.id;
  if (!videoId) return;
  if (!isLoggedIn.value) {
    showLoginPopup()
    return
  }

  const isLiked = video.value?.isLiked
  if (isLiked) {
    lottie.value.goToAndStop(0)
  }
  else {
    lottie.value.goToAndPlay(20)
  }

  try {
    const res = await fetch(`/api/videos/${id}/part`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        isLiked: isLiked ? 0 : 1,
      }),
    })
    if (!res.ok) {
      throw new Error('좋아요 업데이트 실패1')
    }
    refresh();
  } catch (error) {
    console.error('좋아요 업데이트 실패2', error)
  }
}

async function updateViewCount() {
  try {
    const res = await fetch(`/api/videos/${id}/part`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },  
      body: JSON.stringify({
        viewCnt: (video.value?.viewCnt ?? 0 )+ 1,
      }),
    })
    if (!res.ok) {
      throw new Error('조회수 업데이트 실패1')
    }
    refresh();
  } catch(error) {
    console.error('조회수 업데이트 실패2', error)
  }
}

onMounted(async () => {
  await updateViewCount();
})
</script>